<template>
  <menu
    ref="navContainer"
    class="nav_container fixed w-full top-0 left-0 z-20 max-lg:py-3 py-8 transition-transform duration-700 ease-in-out border-b"
    :class="[
      isScrolled || isHoveringCategory
        ? 'bg-white border-neutral-150'
        : 'border-transparent',
      { expanded: isHoveringCategory },
    ]"
    :style="{
      height:
        isHoveringCategory && !isMobile && !isIOS
          ? `calc(var(--nav-height) + ${EXPANDED_HEIGHT})`
          : 'var(--nav-height)',
      borderBottomLeftRadius:
        isHoveringCategory && !isMobile && !isIOS ? '3.75rem' : '0',
      borderBottomRightRadius:
        isHoveringCategory && !isMobile && !isIOS ? '3.75rem' : '0',
    }"
    @mouseleave="handleCategoryMouseLeave"
  >
    <div
      class="w-full max-w-[82.75rem] mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center"
    >
      <div class="max-lg:w-[120px]">
        <router-link to="/main" @mouseenter="handleCategoryMouseLeave">
          <img
            src="/assets/image/logo.svg"
            alt="총회교육.com"
            class="max-lg:w-36"
          />
        </router-link>
      </div>

      <!-- 데스크톱 메뉴 -->
      <div class="flex items-center justify-between gap-10 xl:gap-28">
        <!-- 카테고리 영역 -->
        <ul
          class="hidden lg:flex gap-[4vw] xl:gap-[3.75rem]"
          @mouseenter="handleCategoryMouseEnter"
        >
          <li class="relative">
            <router-link
              to="/hana-bible"
              class="text-lg xl:text-xl font-semibold hover:text-[var(--main-blue)] transition-colors"
              :class="{
                'text-[var(--main-blue)]': hoveredCategory === 'hana-bible',
              }"
            >
              하나 바이블
            </router-link>
            <div
              class="sub_cates"
              :class="{ active: isHoveringCategory }"
              @mouseenter="hoveredCategory = 'hana-bible'"
              @mouseleave="hoveredCategory = ''"
            >
              <router-link to="/hana-bible"> 하나 바이블 소개 </router-link>
              <router-link to="/hana-bible/course"> 과정별 소개 </router-link>
              <router-link to="/hana-bible/board"> 영유아부 </router-link>
              <router-link to="/hana-bible/board">유치부</router-link>
              <router-link to="/hana-bible/board">유년부</router-link>
              <router-link to="/hana-bible/board">초등부</router-link>
              <router-link to="/hana-bible/board">청소년부</router-link>
              <router-link to="/hana-bible/board">대학청년부</router-link>
              <router-link to="/hana-bible/board">구역/장년</router-link>
            </div>
          </li>
          <li class="relative">
            <router-link
              to="/bible-school"
              class="text-lg xl:text-xl font-semibold hover:text-[var(--main-blue)] transition-colors"
              :class="{
                'text-[var(--main-blue)]': hoveredCategory === 'bible-school',
              }"
              >성경학교</router-link
            >
            <div
              class="sub_cates"
              :class="{ active: isHoveringCategory }"
              @mouseenter="hoveredCategory = 'bible-school'"
              @mouseleave="hoveredCategory = ''"
            >
              <router-link to="/bible-school?tab=summer"
                >여름성경학교</router-link
              >
              <router-link to="/bible-school?tab=winter"
                >겨울성경학교</router-link
              >
            </div>
          </li>
          <li class="relative">
            <router-link
              to="/mall/170"
              class="text-lg xl:text-xl font-semibold hover:text-[var(--main-blue)] transition-colors"
              :class="{
                'text-[var(--main-blue)]': hoveredCategory === 'hana-cube',
              }"
              >하나 큐브</router-link
            >
            <div
              class="sub_cates"
              :class="{ active: isHoveringCategory }"
              @mouseenter="hoveredCategory = 'hana-cube'"
              @mouseleave="hoveredCategory = ''"
            >
              <router-link to="/mall/170/172">설교자료</router-link>
              <router-link to="/mall/170/174">절기자료</router-link>
              <router-link to="/mall/136">활동자료</router-link>
              <router-link to="/mall/138/164">행정서식</router-link>
              <router-link to="/mall/138/162">강의영상</router-link>
              <router-link to="/mall/170/171">이미지</router-link>
              <router-link to="/mall/137">찬양</router-link>
            </div>
          </li>
          <li class="relative">
            <a
              href="/conf"
              target="_blank"
              class="text-lg xl:text-xl font-semibold hover:text-[var(--main-blue)] transition-colors"
              :class="{
                'text-[var(--main-blue)]': hoveredCategory === 'conference',
              }"
              >컨퍼런스</a
            >
            <div
              class="sub_cates"
              :class="{ active: isHoveringCategory }"
              @mouseenter="hoveredCategory = 'conference'"
              @mouseleave="hoveredCategory = ''"
            >
              <a href="/conf" target="_blank" class="flex items-center gap-1"
                >현장 컨퍼런스
                <svg
                  width="13"
                  height="13"
                  viewBox="0 0 13 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.30833 5.32C5.07399 5.55441 4.94235 5.87229 4.94235 6.20375C4.94235 6.5352 5.07399 6.85309 5.30833 7.0875L5.36417 7.14333C5.48025 7.25949 5.61808 7.35164 5.76979 7.41451C5.9215 7.47737 6.08411 7.50973 6.24833 7.50973C6.41255 7.50973 6.57516 7.47737 6.72687 7.41451C6.87858 7.35164 7.01642 7.25949 7.1325 7.14333L9.72833 4.5475C9.84833 4.4275 9.93917 4.28917 10 4.14083V10.8333C10 11.2754 9.8244 11.6993 9.51184 12.0118C9.19928 12.3244 8.77536 12.5 8.33333 12.5H1.66667C1.22464 12.5 0.800716 12.3244 0.488155 12.0118C0.175595 11.6993 0 11.2754 0 10.8333V4.16667C0 3.72464 0.175595 3.30072 0.488155 2.98816C0.800716 2.67559 1.22464 2.5 1.66667 2.5H8.20917C8.09671 2.55881 7.99386 2.6344 7.90417 2.72417L5.30833 5.32Z"
                    fill="currentColor"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M11.8483 0.651667C11.8871 0.690372 11.9179 0.736351 11.9389 0.786972C11.9599 0.837593 11.9707 0.891861 11.9707 0.946667C11.9707 1.00147 11.9599 1.05574 11.9389 1.10636C11.9179 1.15698 11.8871 1.20296 11.8483 1.24167L6.545 6.545C6.46687 6.62324 6.36086 6.66724 6.2503 6.66732C6.13973 6.66739 6.03366 6.62354 5.95542 6.54542C5.87718 6.46729 5.83318 6.36128 5.8331 6.25071C5.83302 6.14014 5.87687 6.03407 5.955 5.95583L11.2583 0.651667C11.3365 0.573554 11.4424 0.529672 11.5529 0.529672C11.6634 0.529672 11.7702 0.573554 11.8483 0.651667Z"
                    fill="currentColor"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M7.5 0.416667C7.5 0.30616 7.5439 0.200179 7.62204 0.122039C7.70018 0.0438988 7.80616 0 7.91667 0H12.0833C12.1938 0 12.2998 0.0438988 12.378 0.122039C12.4561 0.200179 12.5 0.30616 12.5 0.416667V4.58333C12.5 4.69384 12.4561 4.79982 12.378 4.87796C12.2998 4.9561 12.1938 5 12.0833 5C11.9728 5 11.8668 4.9561 11.7887 4.87796C11.7106 4.79982 11.6667 4.69384 11.6667 4.58333V0.833333H7.91667C7.80616 0.833333 7.70018 0.789435 7.62204 0.711294C7.5439 0.633154 7.5 0.527174 7.5 0.416667Z"
                    fill="currentColor"
                  /></svg
              ></a>
            </div>
          </li>
          <li class="relative">
            <router-link
              to="/"
              class="text-lg xl:text-xl font-semibold hover:text-[var(--main-blue)] transition-colors"
              :class="{
                'text-[var(--main-blue)]': hoveredCategory === 'ministry',
              }"
              >사역나눔</router-link
            >
            <div
              class="sub_cates"
              :class="{ active: isHoveringCategory }"
              @mouseenter="hoveredCategory = 'ministry'"
              @mouseleave="hoveredCategory = ''"
            >
              <router-link to="/">교회 및 기관자료</router-link>
              <router-link to="/">자료게시판</router-link>
              <router-link to="/">총회 내부교육기관 자료</router-link>
              <router-link to="/">작은교회/군교회 지원</router-link>
              <router-link to="/">사역 신청</router-link>
            </div>
          </li>
        </ul>

        <!-- 우측 버튼 영역 -->
        <aside @mouseenter="handleCategoryMouseLeave">
          <!-- 로그인 X -->
          <VDialog
            v-if="!$store.state.uid.id"
            v-model="isLoginDialogOpen"
            ref="loginDialogRef"
            no-scroll
          >
            <template #toggle="{ bind, on }">
              <li class="">
                <button
                  v-bind="bind"
                  @click="handleLoginButtonClick(on)"
                  class="hidden lg:flex login_btn bg-[var(--d-gray-57)] text-white hover:bg-[var(--main-blue)] transition-colors duration-500 px-4 xl:px-6 py-2 xl:py-3 rounded-full cursor-pointer items-center justify-center"
                >
                  <svg
                    width="45"
                    height="11"
                    viewBox="0 0 52 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="xl:w-[52px] xl:h-[13px]"
                  >
                    <path
                      d="M0.585813 12V0.799999H3.17781V9.888H8.79381V12H0.585813ZM15.4946 12.192C14.6092 12.192 13.7879 12.048 13.0306 11.76C12.2839 11.472 11.6332 11.0667 11.0786 10.544C10.5346 10.0213 10.1079 9.408 9.79856 8.704C9.4999 8 9.35056 7.232 9.35056 6.4C9.35056 5.568 9.4999 4.8 9.79856 4.096C10.1079 3.392 10.5399 2.77867 11.0946 2.256C11.6492 1.73333 12.2999 1.328 13.0466 1.04C13.7932 0.752 14.6039 0.608 15.4786 0.608C16.3639 0.608 17.1746 0.752 17.9106 1.04C18.6572 1.328 19.3026 1.73333 19.8466 2.256C20.4012 2.77867 20.8332 3.392 21.1426 4.096C21.4519 4.78933 21.6066 5.55733 21.6066 6.4C21.6066 7.232 21.4519 8.00533 21.1426 8.72C20.8332 9.424 20.4012 10.0373 19.8466 10.56C19.3026 11.072 18.6572 11.472 17.9106 11.76C17.1746 12.048 16.3692 12.192 15.4946 12.192ZM15.4786 9.984C15.9799 9.984 16.4386 9.89867 16.8546 9.728C17.2812 9.55733 17.6546 9.312 17.9746 8.992C18.2946 8.672 18.5399 8.29333 18.7106 7.856C18.8919 7.41867 18.9826 6.93333 18.9826 6.4C18.9826 5.86667 18.8919 5.38133 18.7106 4.944C18.5399 4.50667 18.2946 4.128 17.9746 3.808C17.6652 3.488 17.2972 3.24267 16.8706 3.072C16.4439 2.90133 15.9799 2.816 15.4786 2.816C14.9772 2.816 14.5132 2.90133 14.0866 3.072C13.6706 3.24267 13.3026 3.488 12.9826 3.808C12.6626 4.128 12.4119 4.50667 12.2306 4.944C12.0599 5.38133 11.9746 5.86667 11.9746 6.4C11.9746 6.92267 12.0599 7.408 12.2306 7.856C12.4119 8.29333 12.6572 8.672 12.9666 8.992C13.2866 9.312 13.6599 9.55733 14.0866 9.728C14.5132 9.89867 14.9772 9.984 15.4786 9.984ZM28.9626 12.192C28.0772 12.192 27.2612 12.0533 26.5146 11.776C25.7786 11.488 25.1332 11.0827 24.5786 10.56C24.0346 10.0373 23.6079 9.424 23.2986 8.72C22.9999 8.016 22.8506 7.24267 22.8506 6.4C22.8506 5.55733 22.9999 4.784 23.2986 4.08C23.6079 3.376 24.0399 2.76267 24.5946 2.24C25.1492 1.71733 25.7999 1.31733 26.5466 1.04C27.2932 0.752 28.1146 0.608 29.0106 0.608C30.0026 0.608 30.8932 0.773333 31.6826 1.104C32.4826 1.43467 33.1546 1.91467 33.6986 2.544L32.0346 4.08C31.6292 3.65333 31.1866 3.33867 30.7066 3.136C30.2266 2.92267 29.7039 2.816 29.1386 2.816C28.5946 2.816 28.0986 2.90133 27.6506 3.072C27.2026 3.24267 26.8132 3.488 26.4826 3.808C26.1626 4.128 25.9119 4.50667 25.7306 4.944C25.5599 5.38133 25.4746 5.86667 25.4746 6.4C25.4746 6.92267 25.5599 7.40267 25.7306 7.84C25.9119 8.27733 26.1626 8.66133 26.4826 8.992C26.8132 9.312 27.1972 9.55733 27.6346 9.728C28.0826 9.89867 28.5732 9.984 29.1066 9.984C29.6186 9.984 30.1146 9.904 30.5946 9.744C31.0852 9.57333 31.5599 9.29067 32.0186 8.896L33.4906 10.768C32.8826 11.2267 32.1732 11.5787 31.3626 11.824C30.5626 12.0693 29.7626 12.192 28.9626 12.192ZM31.1226 10.432V6.224H33.4906V10.768L31.1226 10.432ZM35.8983 12V0.799999H38.4903V12H35.8983ZM41.1483 12V0.799999H43.2923L49.9003 8.864H48.8603V0.799999H51.4203V12H49.2923L42.6683 3.936H43.7083V12H41.1483Z"
                      fill="white"
                    />
                  </svg>
                </button>
              </li>
            </template>

            <template #default="{ close }">
              <div
                class="bg-black bg-opacity-25 w-screen h-screen flex justify-center items-center"
                @click.self="closeLoginDialog"
              >
                <div
                  class="min-w-[25vw] max-xl:min-w-[70vw] max-md:min-w-[88vw] flex flex-col bg-white w-fit rounded-3xl"
                >
                  <button
                    aria-label="close"
                    class="my-dialog__close w-fit mt-3 mr-4 self-end"
                    @click="closeLoginDialog"
                  >
                    <h4 class="text-2xl">
                      <font-awesome-icon icon="fa-solid fa-circle-xmark" />
                    </h4>
                  </button>
                  <div
                    class="login max-lg:border-b border-neutral-300"
                    :class="{ 'bg-sky-50': isMenuVisible }"
                  >
                    <p
                      v-if="isExternalOpen"
                      class="text-center font-medium text-blue-800"
                    >
                      로그인 후 이용 가능합니다
                    </p>
                    <div class="login_inputs max-w-[658px] mx-auto py-5 px-8">
                      <div
                        class="rounded-t-lg overflow-hidden outline outline-1 outline-neutral-300"
                      >
                        <input
                          type="text"
                          class="p-4 w-full"
                          placeholder="아이디를 입력하세요"
                          v-model="state.form.uid"
                        />
                      </div>
                      <div
                        class="mt-[1px] rounded-b-lg overflow-hidden outline outline-1 outline-neutral-300"
                      >
                        <input
                          type="password"
                          class="p-4 w-full"
                          placeholder="비밀번호"
                          v-model="state.form.upw"
                          @keyup.enter="submit()"
                        />
                      </div>

                      <div class="mt-4 mb-5 text-center pb-5">
                        <button
                          class="!rounded w-full border border-main-navy bg-white px-4 py-2 disabled:opacity-50 disabled:cursor-not-allowed"
                          @click="submit()"
                          :disabled="isLoading"
                        >
                          <h5 class="text-main-navy font-medium">
                            {{ isLoading ? "로그인 중..." : "로그인" }}
                          </h5>
                        </button>
                      </div>

                      <div
                        class="flex justify-center items-center gap-2 leading-none md:text-sm"
                      >
                        <router-link to="/help_find" class="hover:underline"
                          >아이디/비밀번호 찾기</router-link
                        >
                        <span class="block bg-black w-[1px] h-[0.8em]"></span>
                        <router-link to="/signup" class="hover:underline"
                          >회원가입</router-link
                        >
                      </div>

                      <!-- 간편 로그인 -->
                      <div>
                        <p class="lg:mt-6 mt-4 text-center font-medium">
                          간편 로그인 및 회원가입
                        </p>
                        <div class="flex justify-center pt-4 gap-4">
                          <naverLoginComponent />
                          <kakaoLoginComponent />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </VDialog>

          <!-- 로그인 O -->
          <ul class="hidden lg:flex items-center gap-4 xl:gap-6" v-else>
            <li class="">
              <router-link
                to="/mypage/contentsBox"
                class="flex items-center justify-center"
              >
                <svg
                  width="20"
                  height="17"
                  viewBox="0 0 22 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  class="xl:w-[22px] xl:h-[19px]"
                >
                  <path
                    d="M18.8571 19C19.6907 19 20.4901 18.6664 21.0795 18.0725C21.6689 17.4786 22 16.6732 22 15.8333V11.0833C22 10.2435 21.6689 9.43803 21.0795 8.84416C20.4901 8.2503 19.6907 7.91667 18.8571 7.91667H3.14286C2.30932 7.91667 1.50992 8.2503 0.920522 8.84416C0.331122 9.43803 0 10.2435 0 11.0833V15.8333C0 16.6732 0.331122 17.4786 0.920522 18.0725C1.50992 18.6664 2.30932 19 3.14286 19H18.8571ZM0 7.543V3.16667C0 2.32681 0.331122 1.52136 0.920522 0.927495C1.50992 0.33363 2.30932 0 3.14286 0H8.778C9.40279 0.000274397 10.0019 0.250472 10.4437 0.695611L12.6668 2.93444C12.8134 3.08328 13.0135 3.16667 13.222 3.16667H18.8571C19.6907 3.16667 20.4901 3.5003 21.0795 4.09416C21.6689 4.68803 22 5.49348 22 6.33333V7.543C21.1367 6.7623 20.0171 6.33137 18.8571 6.33333H3.14286C1.98287 6.33137 0.863257 6.7623 0 7.543Z"
                    fill="currentColor"
                  />
                </svg>
              </router-link>
            </li>
            <li class="top_nav_cates">
              <router-link
                to="/mypage"
                class="relative z-10 flex items-center justify-center !py-0"
              >
                <svg
                  width="21"
                  height="20"
                  viewBox="0 0 23 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  class="xl:w-[23px] xl:h-[22px]"
                >
                  <path
                    d="M11.5 9.23529C12.0362 9.23529 12.5672 9.12879 13.0626 8.92186C13.558 8.71493 14.0082 8.41162 14.3874 8.02926C14.7665 7.6469 15.0673 7.19298 15.2725 6.6934C15.4777 6.19383 15.5833 5.65838 15.5833 5.11765C15.5833 4.57691 15.4777 4.04147 15.2725 3.54189C15.0673 3.04232 14.7665 2.58839 14.3874 2.20603C14.0082 1.82367 13.558 1.52037 13.0626 1.31344C12.5672 1.10651 12.0362 1 11.5 1C10.417 1 9.37842 1.43382 8.61265 2.20603C7.84687 2.97824 7.41667 4.02558 7.41667 5.11765C7.41667 6.20972 7.84687 7.25705 8.61265 8.02926C9.37842 8.80147 10.417 9.23529 11.5 9.23529ZM1 20.2941V21H22V20.2941C22 17.6588 22 16.3412 21.4913 15.3341C21.0439 14.4487 20.33 13.7288 19.452 13.2776C18.4533 12.7647 17.1467 12.7647 14.5333 12.7647H8.46667C5.85333 12.7647 4.54667 12.7647 3.548 13.2776C2.66995 13.7288 1.95607 14.4487 1.50867 15.3341C1 16.3412 1 17.6588 1 20.2941Z"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </router-link>
              <menu class="max-md:!hidden">
                <div class="cates_wr">
                  <router-link to="/mypage">마이페이지</router-link>
                  <router-link to="/mypage/cart">장바구니</router-link>
                  <router-link
                    v-if="$store.state.level.id === 10"
                    to="/management"
                  >
                    컨퍼런스 관리자
                  </router-link>
                  <a
                    v-if="$store.state.level.id === 10"
                    href="http://eduwind-admin.node-www.com/sign"
                    target="_blank"
                  >
                    콘텐츠몰 관리자
                  </a>
                  <a class="cursor-pointer" @click="logout()">로그아웃</a>
                </div>
              </menu>
            </li>
          </ul>
        </aside>
      </div>

      <!-- 모바일 & 태블릿 메뉴 -->
      <div class="lg:hidden flex items-center gap-3">
        <!-- 모바일 우측 아이콘들 -->
        <div class="flex items-center gap-2">
          <!-- 콘텐츠함 -->
          <router-link
            to="/mypage/contentsBox"
            class="p-2 text-[var(--d-gray-57)] hover:text-[var(--main-blue)] transition-colors"
            @click="handleMobileAuthLinkClick"
          >
            <svg
              width="18"
              height="15"
              viewBox="0 0 22 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18.8571 19C19.6907 19 20.4901 18.6664 21.0795 18.0725C21.6689 17.4786 22 16.6732 22 15.8333V11.0833C22 10.2435 21.6689 9.43803 21.0795 8.84416C20.4901 8.2503 19.6907 7.91667 18.8571 7.91667H3.14286C2.30932 7.91667 1.50992 8.2503 0.920522 8.84416C0.331122 9.43803 0 10.2435 0 11.0833V15.8333C0 16.6732 0.331122 17.4786 0.920522 18.0725C1.50992 18.6664 2.30932 19 3.14286 19H18.8571ZM0 7.543V3.16667C0 2.32681 0.331122 1.52136 0.920522 0.927495C1.50992 0.33363 2.30932 0 3.14286 0H8.778C9.40279 0.000274397 10.0019 0.250472 10.4437 0.695611L12.6668 2.93444C12.8134 3.08328 13.0135 3.16667 13.222 3.16667H18.8571C19.6907 3.16667 20.4901 3.5003 21.0795 4.09416C21.6689 4.68803 22 5.49348 22 6.33333V7.543C21.1367 6.7623 20.0171 6.33137 18.8571 6.33333H3.14286C1.98287 6.33137 0.863257 6.7623 0 7.543Z"
                fill="currentColor"
              />
            </svg>
          </router-link>
          <!-- 마이페이지 -->
          <router-link
            to="/mypage"
            class="p-2 text-[var(--d-gray-57)] hover:text-[var(--main-blue)] transition-colors"
            @click="handleMobileAuthLinkClick"
          >
            <svg
              width="19"
              height="18"
              viewBox="0 0 23 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.5 9.23529C12.0362 9.23529 12.5672 9.12879 13.0626 8.92186C13.558 8.71493 14.0082 8.41162 14.3874 8.02926C14.7665 7.6469 15.0673 7.19298 15.2725 6.6934C15.4777 6.19383 15.5833 5.65838 15.5833 5.11765C15.5833 4.57691 15.4777 4.04147 15.2725 3.54189C15.0673 3.04232 14.7665 2.58839 14.3874 2.20603C14.0082 1.82367 13.558 1.52037 13.0626 1.31344C12.5672 1.10651 12.0362 1 11.5 1C10.417 1 9.37842 1.43382 8.61265 2.20603C7.84687 2.97824 7.41667 4.02558 7.41667 5.11765C7.41667 6.20972 7.84687 7.25705 8.61265 8.02926C9.37842 8.80147 10.417 9.23529 11.5 9.23529ZM1 20.2941V21H22V20.2941C22 17.6588 22 16.3412 21.4913 15.3341C21.0439 14.4487 20.33 13.7288 19.452 13.2776C18.4533 12.7647 17.1467 12.7647 14.5333 12.7647H8.46667C5.85333 12.7647 4.54667 12.7647 3.548 13.2776C2.66995 13.7288 1.95607 14.4487 1.50867 15.3341C1 16.3412 1 17.6588 1 20.2941Z"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </router-link>
        </div>

        <!-- 햄버거 메뉴 버튼 -->
        <button
          @click="toggleMobileMenu"
          class="flex flex-col justify-center items-center w-8 h-8 space-y-1.5 focus:outline-none z-50"
          :class="{ 'menu-open': isMobileMenuOpen }"
        >
          <span
            class="block w-6 h-0.5 bg-[var(--d-gray-57)] transition-all duration-300 ease-in-out"
          ></span>
          <span
            class="block w-6 h-0.5 bg-[var(--d-gray-57)] transition-all duration-300 ease-in-out"
          ></span>
          <span
            class="block w-6 h-0.5 bg-[var(--d-gray-57)] transition-all duration-300 ease-in-out"
          ></span>
        </button>
      </div>
    </div>

    <!-- 모바일 사이드 메뉴 -->
    <div
      class="lg:hidden fixed top-0 right-0 w-full h-screen bg-white shadow-2xl transform transition-transform duration-300 ease-in-out z-30"
      :class="[isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full']"
    >
      <div class="flex flex-col h-full">
        <!-- 모바일 메뉴 헤더 -->
        <div
          class="flex justify-between items-center p-5 border-b bg-[var(--main-blue)] text-white"
        >
          <div class="flex items-center space-x-3 divide-x leading-none">
            <router-link to="/main"> 홈 </router-link>
            <button
              v-if="!$store.state.uid.id"
              class="pl-3"
              @click="openMobileLogin"
            >
              LOGIN
            </button>
            <button v-else @click="logout" class="pl-3">LOGOUT</button>
          </div>

          <!-- <button @click="toggleMobileMenu" class="p-2 pr-0">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18 6L6 18M6 6L18 18"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button> -->
        </div>

        <!-- 모바일 메뉴 내용 -->
        <div class="flex-1 overflow-y-auto">
          <!-- 메뉴 -->
          <ul class="pt-2" v-if="!isMobileLoginOpen">
            <li class="mobile-menu-item">
              <button
                @click="toggleMobileSubmenu('hana-bible')"
                class="w-full flex justify-between items-center px-5 py-3 text-left text-lg font-semibold"
              >
                하나바이블
                <svg
                  class="w-5 h-5 transition-transform duration-200"
                  :class="{ 'rotate-180': openSubmenu === 'hana-bible' }"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M19 9l-7 7-7-7"
                  ></path>
                </svg>
              </button>
              <div
                class="submenu overflow-hidden transition-all duration-300 ease-in-out"
                :class="
                  openSubmenu === 'hana-bible'
                    ? 'opacity-100'
                    : 'max-h-0 opacity-0'
                "
              >
                <div class="py-2 bg-gray-50">
                  <router-link
                    to="/hana-bible"
                    class="block px-6 py-2 text-base hover:text-[var(--main-blue)]"
                    >하나 바이블 소개</router-link
                  >
                  <router-link
                    to="/hana-bible/course"
                    class="block px-6 py-2 text-base hover:text-[var(--main-blue)]"
                    >과정별 소개</router-link
                  >
                  <router-link
                    to="/hana-bible/board"
                    class="block px-6 py-2 text-base hover:text-[var(--main-blue)]"
                    >영유아부</router-link
                  >
                  <router-link
                    to="/hana-bible/board"
                    class="block px-6 py-2 text-base hover:text-[var(--main-blue)]"
                    >유치부</router-link
                  >
                  <router-link
                    to="/hana-bible/board"
                    class="block px-6 py-2 text-base hover:text-[var(--main-blue)]"
                    >유년부</router-link
                  >
                  <router-link
                    to="/hana-bible/board"
                    class="block px-6 py-2 text-base hover:text-[var(--main-blue)]"
                    >초등부</router-link
                  >
                  <router-link
                    to="/hana-bible/board"
                    class="block px-6 py-2 text-base hover:text-[var(--main-blue)]"
                    >청소년부</router-link
                  >
                  <router-link
                    to="/hana-bible/board"
                    class="block px-6 py-2 text-base hover:text-[var(--main-blue)]"
                    >대학청년부</router-link
                  >
                  <router-link
                    to="/hana-bible/board"
                    class="block px-6 py-2 text-base hover:text-[var(--main-blue)]"
                    >구역/장년</router-link
                  >
                </div>
              </div>
            </li>

            <li class="mobile-menu-item">
              <button
                @click="toggleMobileSubmenu('bible-school')"
                class="w-full flex justify-between items-center px-5 py-3 text-left text-lg font-semibold"
              >
                성경학교
                <svg
                  class="w-5 h-5 transition-transform duration-200"
                  :class="{ 'rotate-180': openSubmenu === 'bible-school' }"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M19 9l-7 7-7-7"
                  ></path>
                </svg>
              </button>
              <div
                class="submenu overflow-hidden transition-all duration-300 ease-in-out"
                :class="
                  openSubmenu === 'bible-school'
                    ? 'opacity-100'
                    : 'max-h-0 opacity-0'
                "
              >
                <div class="py-2 bg-gray-50">
                  <router-link
                    to="/bible-school?tab=summer"
                    class="block px-6 py-2 text-base hover:text-[var(--main-blue)]"
                    >여름성경학교</router-link
                  >
                  <router-link
                    to="/bible-school?tab=winter"
                    class="block px-6 py-2 text-base hover:text-[var(--main-blue)]"
                    >겨울성경학교</router-link
                  >
                </div>
              </div>
            </li>

            <li class="mobile-menu-item">
              <button
                @click="toggleMobileSubmenu('hana-cube')"
                class="w-full flex justify-between items-center px-5 py-3 text-left text-lg font-semibold"
              >
                하나 큐브
                <svg
                  class="w-5 h-5 transition-transform duration-200"
                  :class="{ 'rotate-180': openSubmenu === 'hana-cube' }"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M19 9l-7 7-7-7"
                  ></path>
                </svg>
              </button>
              <div
                class="submenu overflow-hidden transition-all duration-300 ease-in-out"
                :class="
                  openSubmenu === 'hana-cube'
                    ? 'opacity-100'
                    : 'max-h-0 opacity-0'
                "
              >
                <div class="py-2 bg-gray-50">
                  <router-link
                    to="/mall/170/172"
                    class="block px-6 py-2 text-base hover:text-[var(--main-blue)]"
                    >설교자료</router-link
                  >
                  <router-link
                    to="/mall/170/174"
                    class="block px-6 py-2 text-base hover:text-[var(--main-blue)]"
                    >절기자료</router-link
                  >
                  <router-link
                    to="/mall/136"
                    class="block px-6 py-2 text-base hover:text-[var(--main-blue)]"
                    >활동자료</router-link
                  >
                  <router-link
                    to="/mall/138/164"
                    class="block px-6 py-2 text-base hover:text-[var(--main-blue)]"
                    >행정서식</router-link
                  >
                  <router-link
                    to="/mall/138/162"
                    class="block px-6 py-2 text-base hover:text-[var(--main-blue)]"
                    >강의영상</router-link
                  >
                  <router-link
                    to="/mall/170/171"
                    class="block px-6 py-2 text-base hover:text-[var(--main-blue)]"
                    >이미지</router-link
                  >
                  <router-link
                    to="/mall/137"
                    class="block px-6 py-2 text-base hover:text-[var(--main-blue)]"
                    >찬양</router-link
                  >
                </div>
              </div>
            </li>

            <li class="mobile-menu-item">
              <button
                @click="toggleMobileSubmenu('conference')"
                class="w-full flex justify-between items-center px-5 py-3 text-left text-lg font-semibold"
              >
                컨퍼런스
                <svg
                  class="w-5 h-5 transition-transform duration-200"
                  :class="{ 'rotate-180': openSubmenu === 'conference' }"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M19 9l-7 7-7-7"
                  ></path>
                </svg>
              </button>
              <div
                class="submenu overflow-hidden transition-all duration-300 ease-in-out"
                :class="
                  openSubmenu === 'conference'
                    ? 'opacity-100'
                    : 'max-h-0 opacity-0'
                "
              >
                <div class="py-2 bg-gray-50">
                  <a
                    href="/conf"
                    target="_blank"
                    class="flex items-center gap-2 px-6 py-2 text-base hover:text-[var(--main-blue)]"
                  >
                    현장 컨퍼런스
                    <svg
                      width="13"
                      height="13"
                      viewBox="0 0 13 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5.30833 5.32C5.07399 5.55441 4.94235 5.87229 4.94235 6.20375C4.94235 6.5352 5.07399 6.85309 5.30833 7.0875L5.36417 7.14333C5.48025 7.25949 5.61808 7.35164 5.76979 7.41451C5.9215 7.47737 6.08411 7.50973 6.24833 7.50973C6.41255 7.50973 6.57516 7.47737 6.72687 7.41451C6.87858 7.35164 7.01642 7.25949 7.1325 7.14333L9.72833 4.5475C9.84833 4.4275 9.93917 4.28917 10 4.14083V10.8333C10 11.2754 9.8244 11.6993 9.51184 12.0118C9.19928 12.3244 8.77536 12.5 8.33333 12.5H1.66667C1.22464 12.5 0.800716 12.3244 0.488155 12.0118C0.175595 11.6993 0 11.2754 0 10.8333V4.16667C0 3.72464 0.175595 3.30072 0.488155 2.98816C0.800716 2.67559 1.22464 2.5 1.66667 2.5H8.20917C8.09671 2.55881 7.99386 2.6344 7.90417 2.72417L5.30833 5.32Z"
                        fill="currentColor"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M11.8483 0.651667C11.8871 0.690372 11.9179 0.736351 11.9389 0.786972C11.9599 0.837593 11.9707 0.891861 11.9707 0.946667C11.9707 1.00147 11.9599 1.05574 11.9389 1.10636C11.9179 1.15698 11.8871 1.20296 11.8483 1.24167L6.545 6.545C6.46687 6.62324 6.36086 6.66724 6.2503 6.66732C6.13973 6.66739 6.03366 6.62354 5.95542 6.54542C5.87718 6.46729 5.83318 6.36128 5.8331 6.25071C5.83302 6.14014 5.87687 6.03407 5.955 5.95583L11.2583 0.651667C11.3365 0.573554 11.4424 0.529672 11.5529 0.529672C11.6634 0.529672 11.7702 0.573554 11.8483 0.651667Z"
                        fill="currentColor"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M7.5 0.416667C7.5 0.30616 7.5439 0.200179 7.62204 0.122039C7.70018 0.0438988 7.80616 0 7.91667 0H12.0833C12.1938 0 12.2998 0.0438988 12.378 0.122039C12.4561 0.200179 12.5 0.30616 12.5 0.416667V4.58333C12.5 4.69384 12.4561 4.79982 12.378 4.87796C12.2998 4.9561 12.1938 5 12.0833 5C11.9728 5 11.8668 4.9561 11.7887 4.87796C11.7106 4.79982 11.6667 4.69384 11.6667 4.58333V0.833333H7.91667C7.80616 0.833333 7.70018 0.789435 7.62204 0.711294C7.5439 0.633154 7.5 0.527174 7.5 0.416667Z"
                        fill="currentColor"
                      />
                    </svg>
                  </a>
                  <!-- <router-link
                    to="/"
                    class="block px-6 py-2 text-base hover:text-[var(--main-blue)]"
                    >온라인 컨퍼런스</router-link
                  >
                  <router-link
                    to="/"
                    class="block px-6 py-2 text-base hover:text-[var(--main-blue)]"
                    >등록확인</router-link
                  > -->
                </div>
              </div>
            </li>

            <li class="mobile-menu-item">
              <button
                @click="toggleMobileSubmenu('ministry')"
                class="w-full flex justify-between items-center px-5 py-3 text-left text-lg font-semibold"
              >
                사역나눔
                <svg
                  class="w-5 h-5 transition-transform duration-200"
                  :class="{ 'rotate-180': openSubmenu === 'ministry' }"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M19 9l-7 7-7-7"
                  ></path>
                </svg>
              </button>
              <div
                class="submenu overflow-hidden transition-all duration-300 ease-in-out"
                :class="
                  openSubmenu === 'ministry'
                    ? 'opacity-100'
                    : 'max-h-0 opacity-0'
                "
              >
                <div class="py-2 bg-gray-50">
                  <router-link
                    to="/"
                    class="block px-6 py-2 text-base hover:text-[var(--main-blue)]"
                    >교회 및 기관자료</router-link
                  >
                  <router-link
                    to="/"
                    class="block px-6 py-2 text-base hover:text-[var(--main-blue)]"
                    >자료게시판</router-link
                  >
                  <router-link
                    to="/"
                    class="block px-6 py-2 text-base hover:text-[var(--main-blue)]"
                    >총회 내부교육기관 자료</router-link
                  >
                  <router-link
                    to="/"
                    class="block px-6 py-2 text-base hover:text-[var(--main-blue)]"
                    >작은교회/군교회 지원</router-link
                  >
                  <router-link
                    to="/"
                    class="block px-6 py-2 text-base hover:text-[var(--main-blue)]"
                    >사역 신청</router-link
                  >
                </div>
              </div>
            </li>
          </ul>

          <!-- 로그인 -->
          <div v-else>
            <div class="login" :class="{ 'bg-sky-50': isMenuVisible }">
              <div class="login_inputs max-w-[658px] mx-auto p-5 mt-2">
                <div
                  class="rounded-t-lg overflow-hidden outline outline-1 outline-neutral-300"
                >
                  <input
                    type="text"
                    class="p-4 w-full"
                    placeholder="아이디를 입력하세요"
                    v-model="state.form.uid"
                  />
                </div>
                <div
                  class="mt-[1px] rounded-b-lg overflow-hidden outline outline-1 outline-neutral-300"
                >
                  <input
                    type="password"
                    class="p-4 w-full"
                    placeholder="비밀번호"
                    v-model="state.form.upw"
                    @keyup.enter="submit()"
                  />
                </div>

                <div class="mt-4 mb-5 text-center pb-5">
                  <button
                    class="!rounded w-1/2 border border-main-navy bg-white p-4 disabled:opacity-50 disabled:cursor-not-allowed"
                    @click="submit()"
                    :disabled="isLoading"
                  >
                    <h5 class="text-main-navy font-medium">
                      {{ isLoading ? "로그인 중..." : "로그인" }}
                    </h5>
                  </button>
                </div>

                <div
                  class="flex justify-center items-center gap-2 leading-none md:text-sm"
                >
                  <router-link to="/help_find" class="hover:underline"
                    >아이디/비밀번호 찾기</router-link
                  >
                  <span class="block bg-black w-[1px] h-[0.8em]"></span>
                  <router-link to="/signup" class="hover:underline"
                    >회원가입</router-link
                  >
                </div>

                <!-- 간편 로그인 -->
                <div>
                  <p class="lg:mt-6 mt-4 text-center font-medium">
                    간편 로그인 및 회원가입
                  </p>
                  <div class="flex justify-center pt-4 gap-4">
                    <naverLoginComponent />
                    <kakaoLoginComponent />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </menu>
</template>

<script setup>
import { ref, onMounted, onUnmounted, reactive, nextTick } from "vue";
import { VDialog } from "vuetensils/src/components";
import axios from "axios";
import { onBeforeRouteLeave } from "vue-router";

import store from "@/store";
import router from "@/router";

import naverLoginComponent from "@/components/naverLoginComponent.vue";
import kakaoLoginComponent from "@/components/kakaoLoginComponent.vue";
import { useLoginDialog } from "@/composables/useLoginDialog";

// ============================================
// 상수 정의
// ============================================
const SCROLL_THRESHOLD = 50; // 스크롤 감지 임계값
const SCROLL_DIFFERENCE_THRESHOLD = 5; // 스크롤 변화량 임계값
const MOBILE_BREAKPOINT = 1024; // 모바일 브레이크포인트 (lg)
const NAV_HEIGHT_OFFSET = 80; // 네비게이션 높이 오프셋
const EXPANDED_HEIGHT = "20rem"; // 호버 시 확장 높이

// ============================================
// 반응형 상태 변수
// ============================================
// 네비게이션 관련
const navContainer = ref(null);
const isScrolled = ref(false);
const lastScrollY = ref(0);
const navHeight = ref(0);
const isHoveringCategory = ref(false);
const baseNavHeight = ref("auto");
const hoveredCategory = ref("");

// 모바일 관련
const isMobileMenuOpen = ref(false);
const openSubmenu = ref("");
const isMobile = ref(false);
const isMobileLoginOpen = ref(false);

// iOS 관련
const isIOS = ref(false);
let touchStartHandler = null;
let touchMoveHandler = null;

// ============================================
// 기기 감지 함수
// ============================================
/**
 * iOS 기기 감지
 * iOS의 모든 브라우저는 WebKit을 사용하므로 동일한 문제 발생
 */
const checkIOS = () => {
  const userAgent = window.navigator.userAgent.toLowerCase();
  isIOS.value =
    /iphone|ipad|ipod/.test(userAgent) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1) ||
    (/webkit/.test(userAgent) && /mobile|iphone|ipad|ipod/.test(userAgent));
};

/**
 * 모바일 기기 감지
 */
const checkMobile = () => {
  isMobile.value = window.innerWidth < MOBILE_BREAKPOINT;
};

// ============================================
// 모바일 메뉴 관련 함수
// ============================================
/**
 * 모바일 메뉴 토글
 */
const toggleMobileMenu = () => {
  isMobileMenuOpen.value = !isMobileMenuOpen.value;
  if (isMobileMenuOpen.value) {
    document.body.style.overflow = "hidden";
    isMobileLoginOpen.value = false;
  } else {
    document.body.style.overflow = "";
    openSubmenu.value = "";
  }
};

/**
 * 모바일 메뉴 닫기
 */
const closeMobileMenu = () => {
  isMobileMenuOpen.value = false;
  document.body.style.overflow = "";
  openSubmenu.value = "";
  isMobileLoginOpen.value = false;
};

/**
 * 모바일 서브메뉴 토글
 */
const toggleMobileSubmenu = (submenuName) => {
  openSubmenu.value = openSubmenu.value === submenuName ? "" : submenuName;
};

/**
 * 모바일 로그인 화면 토글
 */
const openMobileLogin = () => {
  if (isMobileLoginOpen.value) {
    isMobileLoginOpen.value = false;
  } else {
    if (!isMobileMenuOpen.value) {
      isMobileMenuOpen.value = true;
    }
    isMobileLoginOpen.value = true;
  }
};

/**
 * 모바일 헤더 아이콘 클릭 시 인증 필요 처리
 */
const handleMobileAuthLinkClick = (event) => {
  if (!store.state.uid.id) {
    event.preventDefault();
    openMobileLogin();
  }
};

// ============================================
// 스크롤 및 네비게이션 관련 함수
// ============================================
/**
 * 스크롤 위치 감지 및 네비게이션 제어
 */
const handleScroll = () => {
  const currentScrollY = window.scrollY;

  // iOS WebKit에서 스크롤 시 호버 상태 강제 리셋
  if (isIOS.value && isHoveringCategory.value) {
    isHoveringCategory.value = false;
  }

  // 스크롤 위치에 따른 배경색 변경
  isScrolled.value = currentScrollY > SCROLL_THRESHOLD;

  // 스크롤 방향에 따른 네비게이션 숨김/표시
  if (navContainer.value && (!isHoveringCategory.value || isIOS.value)) {
    const scrollDifference = currentScrollY - lastScrollY.value;

    // 스크롤 변화량이 작으면 무시 (height 변화로 인한 미세한 스크롤 변화 방지)
    if (Math.abs(scrollDifference) < SCROLL_DIFFERENCE_THRESHOLD) {
      lastScrollY.value = currentScrollY;
      return;
    }

    if (
      currentScrollY > lastScrollY.value &&
      currentScrollY > navHeight.value
    ) {
      // 스크롤 다운: 네비게이션 숨김
      navContainer.value.style.transform = `translateY(-${navHeight.value}px)`;
    } else {
      // 스크롤 업: 네비게이션 표시
      navContainer.value.style.transform = "translateY(0)";
    }
  }

  lastScrollY.value = currentScrollY;
};

/**
 * 카테고리 마우스 진입 (데스크톱 전용)
 */
const handleCategoryMouseEnter = () => {
  if (!isMobile.value && !isIOS.value) {
    isHoveringCategory.value = true;
    if (navContainer.value) {
      navContainer.value.style.transform = "translateY(0)";
    }
  }
};

/**
 * 카테고리 마우스 이탈 (데스크톱 전용)
 */
const handleCategoryMouseLeave = () => {
  if (!isMobile.value && !isIOS.value) {
    isHoveringCategory.value = false;
  }
};

// ============================================
// 로그인 관련 상태 및 함수
// ============================================
const state = reactive({
  form: {
    uid: "",
    upw: "",
    sns_type: "",
  },
  conference_idx: 0,
});

const isLoading = ref(false);
const isMenuVisible = ref(false);

// 로그인 다이얼로그 composable 사용
const { isLoginDialogOpen, loginDialogRef, isExternalOpen, closeLoginDialog } =
  useLoginDialog();

/**
 * 메뉴 표시/숨김 토글
 */
const toggleMenu = () => {
  isMenuVisible.value = !isMenuVisible.value;
};

/**
 * 로그인 버튼 클릭 핸들러 (Nav 버튼 클릭 시 플래그 리셋)
 */
const handleLoginButtonClick = (on) => {
  isExternalOpen.value = false; // Nav 버튼 클릭 시 플래그 리셋
  if (on && typeof on.click === "function") {
    on.click();
  }
};

/**
 * 로그인 입력값 유효성 검사
 */
const validateLoginForm = () => {
  if (!state.form.uid.trim()) {
    alert("아이디를 입력하세요.");
    return false;
  }

  if (!state.form.upw.trim()) {
    alert("비밀번호를 입력하세요.");
    return false;
  }

  return true;
};

/**
 * 로그인 처리
 */
const submit = async () => {
  if (!validateLoginForm()) {
    return;
  }

  isLoading.value = true;

  try {
    const response = await axios.post("/api/account/login", state.form);
    console.log("로그인 응답:", response.data);

    if (response.data.err_code === 0) {
      const { accessToken } = response.data.contents.body;
      localStorage.setItem("authorization", accessToken);
      store.commit("setAccount", state.form.uid);

      await router.push({ path: "/" });
      window.location.reload();

      state.form.uid = "";
      state.form.upw = "";
    } else {
      alert(response.data.err_msg || "로그인에 실패했습니다.");
    }
  } catch (error) {
    console.error("로그인 오류:", error);

    if (error.response) {
      const statusCode = error.response.status;
      if (statusCode === 401) {
        alert("아이디 또는 비밀번호를 확인하세요.");
      } else if (statusCode === 500) {
        alert("오류가 발생했습니다. 잠시 후 다시 시도해주세요.");
      } else {
        alert("로그인 중 오류가 발생했습니다.");
      }
    } else {
      alert("네트워크 연결을 확인하고 다시 시도해주세요.");
    }
  } finally {
    isLoading.value = false;
  }
};

/**
 * 로그아웃 처리
 */
const logout = async () => {
  const confirmed = confirm("로그아웃 하시겠습니까?");
  if (!confirmed) {
    return;
  }

  try {
    localStorage.removeItem("authorization");
    store.commit("setAccount", 0);
    store.commit("setLevel", 0);
    store.commit("setUid", "");

    state.form.uid = "";
    state.form.upw = "";
    state.form.sns_type = "";

    await router.push({ path: "/main" });
    window.location.reload();
  } catch (error) {
    console.error("로그아웃 오류:", error);
    localStorage.removeItem("authorization");
    store.commit("setAccount", 0);
    store.commit("setLevel", 0);
    store.commit("setUid", "");
    await router.push({ path: "/main" });
  }
};

// ============================================
// 기타 유틸리티 함수
// ============================================
const cartCount = ref(0);

/**
 * 장바구니 개수 조회
 */
const getCart = async () => {
  try {
    const { data, status } = await axios.get("/new_api/customer/cart/v2/count");
    if (status === 200 && data.code === "200") {
      cartCount.value = data.data.amount;
    }
  } catch (error) {
    console.error("장바구니 조회 오류:", error);
    cartCount.value = 0;
  }
};

/**
 * 인증 상태 확인
 */
const checkAuthStatus = () => {
  const token = localStorage.getItem("authorization");
  if (token) {
    // 토큰이 있으면 스토어 상태 업데이트 (필요시)
  }
};

/**
 * 윈도우 리사이즈 핸들러
 */
const handleResize = () => {
  checkMobile();
  if (isMobile.value) {
    isHoveringCategory.value = false;
  }
  if (!isMobile.value && isMobileMenuOpen.value) {
    closeMobileMenu();
  }
};

/**
 * iOS 터치 이벤트 핸들러 설정
 */
const setupIOSTouchHandlers = () => {
  if (!isIOS.value) return;

  touchStartHandler = () => {
    if (isHoveringCategory.value) {
      isHoveringCategory.value = false;
    }
  };

  touchMoveHandler = () => {
    if (isHoveringCategory.value) {
      isHoveringCategory.value = false;
    }
  };

  document.addEventListener("touchstart", touchStartHandler, { passive: true });
  document.addEventListener("touchmove", touchMoveHandler, { passive: true });
};

/**
 * 네비게이션 높이 초기화
 */
const initializeNavHeight = () => {
  if (navContainer.value) {
    navHeight.value = navContainer.value.offsetHeight + NAV_HEIGHT_OFFSET;
    baseNavHeight.value = `${navContainer.value.offsetHeight}px`;
    document.documentElement.style.setProperty(
      "--nav-height",
      baseNavHeight.value
    );
  }
};

// ============================================
// 라이프사이클 훅
// ============================================
/**
 * 페이지 이동 시 메뉴 상태 초기화
 */
onBeforeRouteLeave(() => {
  isMenuVisible.value = false;
});

/**
 * 컴포넌트 마운트 시 초기화
 */
onMounted(() => {
  // 기기 감지
  checkIOS();
  checkMobile();

  // 네비게이션 높이 초기화
  initializeNavHeight();

  // iOS 터치 이벤트 핸들러 설정
  setupIOSTouchHandlers();

  // 이벤트 리스너 등록
  window.addEventListener("scroll", handleScroll, { passive: true });
  window.addEventListener("resize", handleResize, { passive: true });

  // 데이터 로드
  getCart();
  checkAuthStatus();
});

/**
 * 컴포넌트 언마운트 시 정리
 */
onUnmounted(() => {
  // 이벤트 리스너 제거
  window.removeEventListener("scroll", handleScroll);
  window.removeEventListener("resize", handleResize);

  // iOS 터치 이벤트 리스너 제거
  if (isIOS.value) {
    if (touchStartHandler) {
      document.removeEventListener("touchstart", touchStartHandler);
    }
    if (touchMoveHandler) {
      document.removeEventListener("touchmove", touchMoveHandler);
    }
  }

  // body 스크롤 복원
  document.body.style.overflow = "";
});
</script>

<style scoped>
/* 모바일 메뉴 애니메이션 */
.mobile-menu-item .submenu {
  transition: max-height 0.3s ease-in-out, opacity 0.3s ease-in-out;
}

/* 햄버거 메뉴 애니메이션 */
.menu-open span:nth-child(1) {
  transform: rotate(45deg) translate(5px, 5px);
  background-color: white;
}

.menu-open span:nth-child(2) {
  opacity: 0;
}

.menu-open span:nth-child(3) {
  transform: rotate(-45deg) translate(7px, -6px);
  background-color: white;
}

/* 스크롤바 숨김 (모바일 메뉴용) */
.overflow-y-auto::-webkit-scrollbar {
  display: none;
}

.overflow-y-auto {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

/* 포커스 상태 개선 */
.focus\:outline-none:focus {
  outline: 2px solid var(--main-blue);
  outline-offset: 2px;
}

/* 반응형 네비게이션 확장 상태 */
.expanded {
  box-shadow: 0 10px 25px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05);
}

/* 모바일에서 터치 피드백 개선 */
@media (max-width: 1023px) {
  .hover\:bg-gray-50:active {
    background-color: rgb(249 250 251);
  }

  .hover\:text-\[var\(--main-blue\)\]:active {
    color: var(--main-blue);
  }
}

/* 고해상도 디스플레이 대응 */
@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
  .nav_logo img {
    image-rendering: -webkit-optimize-contrast;
    image-rendering: crisp-edges;
  }
}
</style>
